"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FormMessage;

var _react = _interopRequireDefault(require("react"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _alertCircle = _interopRequireDefault(require("@remote-com/norma/icons/alert-circle.svg"));

var _checkCircle = _interopRequireDefault(require("@remote-com/norma/icons/check-circle.svg"));

var _info = _interopRequireDefault(require("@remote-com/norma/icons/info.svg"));

var _timesCircle = _interopRequireDefault(require("@remote-com/norma/icons/times-circle.svg"));

var _FormMessage = require("./FormMessage.styled");

var __jsx = _react["default"].createElement;

function getFormMessageIcon(props) {
  switch (true) {
    case props.error:
      return _timesCircle["default"];

    case props.warning:
      return _info["default"];

    case props.success:
      return _checkCircle["default"];

    default:
      return _alertCircle["default"];
  }
}
/**
 *
 * @deprecated use src/components/FeedbackMessage
 */


function FormMessage(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);
  var FormMessageIcon = getFormMessageIcon(props);
  return __jsx(_FormMessage.FormMessage, props, __jsx(_FormMessage.FormMessageIconContainer, null, __jsx(FormMessageIcon, null)), children);
}